import React from "react";
import { motion } from "framer-motion";
import { Award, BadgeCheck, HandshakeIcon, Star } from "lucide-react";

const badges = [
  { icon: Award, title: "Quality Curated", body: "Every business is carefully reviewed." },
  { icon: BadgeCheck, title: "Verified Businesses", body: "Trust built through transparent profiles." },
  { icon: HandshakeIcon, title: "Trusted by Buyers", body: "Meaningful, credible business connections." },
  { icon: Star, title: "Committed to Excellence", body: "Continuously raising the bar for quality." },
];

export default function TrustedCommunity() {
  return (
    <section id="trust" className="py-24 md:py-32 bg-brand-wine text-white relative overflow-hidden" data-testid="trust-section">
      <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-white/5" />
      <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-white/5" />

      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <span className="text-xs uppercase tracking-[0.25em] font-semibold text-white/70">
              Why Yuukke
            </span>
            <h2 className="mt-4 font-serif text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight leading-[1.1]">
              A trusted community, <span className="italic">built on credibility</span>.
            </h2>
            <p className="mt-6 text-white/80 text-lg leading-relaxed">
              Yuukke was founded on a simple belief: women-led businesses don&apos;t lack talent. They often lack visibility, access, and opportunities. The Business Exchange bridges that gap.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {badges.map((b, i) => {
              const Icon = b.icon;
              return (
                <motion.div
                  key={b.title}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.08 }}
                  className="bg-white/[0.06] backdrop-blur-sm border border-white/15 rounded-2xl p-6 hover:bg-white/[0.09] transition-colors"
                  data-testid={`badge-${b.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                >
                  <div className="w-12 h-12 rounded-full bg-white/10 border border-white/20 flex items-center justify-center mb-4">
                    <Icon size={20} strokeWidth={1.6} />
                  </div>
                  <h3 className="font-serif text-2xl font-semibold">{b.title}</h3>
                  <p className="mt-2 text-white/75 text-[15px] leading-relaxed">{b.body}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
